import gettext from '@sdk/lang/gettext';

import { useRequestMessageNotification } from './notificationRequestBanner.hooks';
import { Button, Wrapper } from './notificationRequestBanner.styles';

export const NotificationRequestBanner = () => {
  const { isDecisionPending, readUsersDecision } = useRequestMessageNotification();

  if (!isDecisionPending) return null;

  return (
    <Wrapper>
      {gettext('Would you like to receive a desktop notification when you receive new messages?')}

      <Button onClick={() => readUsersDecision(true)}>{gettext('Yes')}</Button>
      <Button secondary onClick={() => readUsersDecision(false)}>
        {gettext('No')}
      </Button>
    </Wrapper>
  );
};
